import { Routes, UrlMatcher, UrlSegment } from '@angular/router';
import { HomePage } from './home/home.page';

/**
 * Matches a single URL segment whose value looks like a site code (e.g. "S12345").
 * Lets `https://app.sravyaa.in/Sxxxxx` resolve directly to the public website view.
 */
const siteCodeMatcher: UrlMatcher = (segments: UrlSegment[]) => {
  if (segments.length === 1 && /^S[A-Za-z0-9]+$/.test(segments[0].path)) {
    return { consumed: segments, posParams: { code: segments[0] } };
  }
  return null;
};

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomePage,
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./auth/auth.page').then(m => m.AuthPage),
  },
  {
    path: 'show/:code/:lang',
    loadComponent: () =>
      import('./pages/show/show.page').then(m => m.Show),
  },
  {
    path: 'show/:code',
    loadComponent: () =>
      import('./pages/show/show.page').then(m => m.Show),
  },
  {
    path: 'level2',
    loadComponent: () =>
      import('./pages/level2/level2.page').then(m => m.Level2Page),
  },
  {
    path: 'backend',
    loadComponent: () =>
      import('./pages/postdata/postdata.page').then(m => m.PostDataPage),
  },
  {
    path: 'web/venue/:code',
    loadComponent: () =>
      import('./pages/web/web-venue.page').then(m => m.WebVenuePage),
  },
  {
    path: 'web/site/:code',
    loadComponent: () =>
      import('./pages/web/web-site.page').then(m => m.WebSitePage),
  },
  {
    path: 'web/:code',
    loadComponent: () =>
      import('./pages/web/web-venue.page').then(m => m.WebVenuePage),
  },
  {
    matcher: siteCodeMatcher,
    loadComponent: () =>
      import('./pages/web/web-site.page').then(m => m.WebSitePage),
  },
];





// Previous

// import { Routes } from '@angular/router';

// export const routes: Routes = [
//   {
//     path: 'home',
//     loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
//   },
//   {
//     path: '',
//     redirectTo: 'home',
//     pathMatch: 'full',
//   },
// ];
